"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.createCallable = createCallable, exports.wrapDisplayName = wrapDisplayName, exports.stringToDate = stringToDate, Object.defineProperty(exports, "getEventsFromInput", {
  enumerable: !0,
  get: function get() {
    return _events.getEventsFromInput;
  }
});

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction")),
    _events = require("./events");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function createCallable(f) {
  return (0, _isFunction2.default)(f) ? f : function () {
    return f;
  };
}

function getDisplayName(Component) {
  return "string" == typeof Component ? Component : Component ? Component.displayName || Component.name || "Component" : void 0;
}

function wrapDisplayName(BaseComponent, hocName) {
  return "".concat(hocName, "(").concat(getDisplayName(BaseComponent), ")");
}

function stringToDate(strInput) {
  try {
    return new Date(JSON.parse(strInput));
  } catch (err) {
    return console.error("Error parsing string to date:", err.message || err), strInput;
  }
}